module.exports = __webpack_public_path__ + "img/IMG_5002_L_WoodMatted_MockedUp.9f2eed8e.jpg";